import { IconReply } from "@consta/icons/IconReply";
import { IconExit } from "@consta/icons/IconExit";
import { IconOpenInNew } from "@consta/icons/IconOpenInNew";
import { HeaderContextItemType } from "../../../enums/context-item-type";
export var CONTEXT_ITEMS = [
    {
        label: HeaderContextItemType.FEEDBACK,
        imageLeft: IconReply,
    },
    {
        label: HeaderContextItemType.DOCS,
        imageLeft: IconOpenInNew,
    },
    {
        label: HeaderContextItemType.SIGNOUT,
        imageLeft: IconExit,
    },
];
